import { Action, History, Location, createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export type { Action, Location, History };
